import React from 'react';
import { PaymentMethodType } from '../../../models/PaymentMethodType';
import { useGetActiveBudgetsQuery } from '../../../redux/api/budgetApi';
import { useAppSelector } from '../../../redux/hooks';
import { selectPaymentMethodLabels } from '../../../redux/selectors/checkoutSelectors';
import PassiveRow from '../PassiveRow';

export default function PaymentSummaryBudgetInfo({ budgetId }: { budgetId: string }) {
  const { data: budgets } = useGetActiveBudgetsQuery();
  const budget = budgets?.find((b) => b._id === budgetId);
  const paymentMethodLabels = useAppSelector(selectPaymentMethodLabels);
  const budgetLabel = paymentMethodLabels[PaymentMethodType.BUDGET];

  if (budget) {
    return <PassiveRow field={`${budgetLabel} Name`} value={budget.plan.name} />;
  }
  return <></>;
}
